import Vue from 'vue'
import VueI18n from 'vue-i18n'
import config from './config'

Vue.use(VueI18n)

export default new VueI18n(config)
